import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';

import { AGENTROLE } from '../../../constants';
import { MoodMeter } from '../../../features/moodMeter';
import { useGetUserAboutMePersonalizationQuery } from '../../../features/moodMeter/MoodMeterSlice';
import Emojis from '../../../features/moodMeter/emojis/Emojis';
import IconProvider from '../../../utils/IconProvider';
import './LeftDrawerEmojis.css';

type MoodNotificationProps = {
    empId: string;
    role: string;
};

const LeftDrawerEmojis = ({ empId, role }: MoodNotificationProps) => {
    const [showModal, setShowModal] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [managerNumber, setManagerNumber] = useState<string | null | undefined>(undefined);
    const [moodType, setMoodType] = useState<string | undefined>(undefined);

    const { data: getPersonalizData } = useGetUserAboutMePersonalizationQuery(
        { employeeNumber: empId },
        { skip: !empId }
    );

    useEffect(() => {
        if (getPersonalizData) {
            const data = getPersonalizData.data;
            if (data && data?.length > 0) {
                setManagerNumber(data[0].manager_number);
            }
        }
    }, [getPersonalizData]);

    const closeModal = () => {
        setShowModal(false);
    };
    const handleModal = () => {
        setShowModal(true);
    };
    const toggleExpanded = () => {
        setExpanded((prev) => !prev);
    };

    return (
        <>
            <MoodMeter closeModal={closeModal} showModal={showModal} managerNumber={managerNumber} />
            <div className="left-emojis-drawer">
                {role === AGENTROLE ? (
                    <Button
                        className="p-button-rounded p-button-icon-only drawerEmojisButton"
                        aria-label="Mood Meter"
                        style={{ width: '100%', height: '100%' }}
                        data-testid="agentEmojisButton"
                        onClick={handleModal}
                    >
                        <IconProvider acrn="FLOATING" />
                    </Button>
                ) : (
                    <>
                        {expanded && (
                            <Emojis
                                moodType={moodType}
                                onMoodTypeChange={setMoodType}
                                empId={empId}
                                role={role}
                                onClosePanel={toggleExpanded}
                                supervisorId={managerNumber}
                            />
                        )}
                        <Button
                            className="p-button-rounded p-button-icon-only drawerEmojisButton"
                            aria-label="Mood Meter Emojis"
                            style={{ width: '100%', height: '100%' }}
                            data-testid="emojisButton"
                            onClick={toggleExpanded}
                        >
                            <IconProvider acrn="FLOATING" />
                        </Button>
                    </>
                )}
            </div>
        </>
    );
};

export default LeftDrawerEmojis;
